// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../assets/css/colors';
import QuestionIcon from '../../Icons/Question';
import { below } from "../../../assets/css/media";

const TooltipBar = styled.div`
	display: inline-flex;
	position: relative;
	flex-basis: 8%;
	justify-content: center;
	align-items: center;
	&:hover {
		>	.txt {
				text-transform: none;
				display: block;
				margin-right: ${({ show_on_left }) => show_on_left ? '1em' : 'initial'}
			}
	}


`;
const getArrow = ({ show_on_left }) => {
	if (show_on_left) {
		return css`
			border-width: 4.5px 0 4.5px 4px;
			border-color: transparent transparent transparent ${colors.nrlGreen};
			right: auto;
			left: 100%;
		`;
	}
	return css`
		border-color: transparent ${colors.nrlGreen} transparent transparent;
		border-width: 4.5px 4px 4.5px 0;
		right:  100%;
		left: auto;
	`;
};

const ToolTipText = styled.div`

	display: none;
	width: 20em;
	font-size: 12px;
	background: ${colors.nrlGreen};
	color: ${colors.title};
	position: absolute;
	top: 50%;
	right:  ${({ show_on_left  }) => show_on_left  ?  '100%' : 'auto'};
	left: ${({ show_on_left  }) => show_on_left  ? 'initial' : '100%'};
	z-index: 2;
	padding: 1em;
	border-radius: 3px;
	transform: translateY(-50%);
	text-align: center;
	&:before {
		content: '';
		display: block;
		width: 0;
		height: 0;
		border-style: solid;
		${getArrow};
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	${({ mobile_show_on_right }) => mobile_show_on_right ? '' : (
		below.desktop`
			right: 100%;
			left: auto;
			&:before {
				content: '';
				display: block;
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 4.5px 0 4.5px 4px;
				border-color: transparent transparent transparent ${colors.nrlGreen};
				position: absolute;
				top: 50%;
				right: auto;
				left: 100%;
			}
		`
	)}
	
	h4 {
		margin: 0 0 .5em 0;
		font-weight: bold;
		display: none;
	}
	p {
		line-height: 1.2;
		margin: 0;
		font-weight: normal;
		text-transform: unset;
	}
`;

const ToolTipIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	background: ${({ background }) => background || '#ffffff'};
	border: 1px solid ${colors.lightGreen};
	border-radius: 50%;
	font-size: 12px;
	height: 24px;
	width: 24px;
	font-weight: bold;

	&:hover {
		background: ${colors.nrlGreen};
		color: #ffffff;
	}

`;

type Props = {
	title: string,
	icon_color?: string,
	description?: string,
	show_on_left?: boolean,
	children?: React.Node,
	icon_background?: string,
	mobile_show_on_right?: boolean
}

export const Tooltip = ({
	title, description, show_on_left = false,
	icon_background, children, mobile_show_on_right = false
}: Props) => (
	<TooltipBar
		show_on_left={show_on_left}>
		<ToolTipText
			className={'txt'}
			show_on_left={show_on_left}
			mobile_show_on_right={mobile_show_on_right}
		>
			<h4>{title}</h4>
			{children ? children : (
				<p>{description}</p>
			)}
		</ToolTipText>
		<ToolTipIcon background={icon_background}>
			<QuestionIcon />
		</ToolTipIcon>
	</TooltipBar>
);

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/Form/Tooltip/index.js